export default {
    coffeeData: {
        coffeeSpecies: "Spesies Kopi",
        coffeeCherryQuality: "Kualitas Biji Kopi Cherry",
        processingBatchQuality: "Kualitas Batch Pengolahan",
        greenCoffeeQuality: "Kualitas Kopi Hijau",
        processType: "Jenis Proses",
    },
    memberDataSection: {
        import: "Impor",
        buyingStation: "Stasiun Pembelian",
        factory: "Pabrik",
        factories: "Pabrik",
        societies: "Masyarakat",
        factoriesName: "Nama Pabrik",
        factoriesProdChart: "Grafik Produksi Pabrik",
        factoryInfo: "Informasi Pabrik",
        factoryDashboard: "Dasbor Pabrik",
        factoryDashboardPage: {
            title: "Dasbor Pabrik",
            close: "Tutup",
            resetFilters: "Atur Ulang Filter",
            apply: "Terapkan",
            monthlySupplyTrend: "Tren Pasokan Bulanan",
            processingEfficiency: "Efisiensi Pemrosesan",
            funnelChart: "Grafik Corong - Input -> Output",
            totalLoss: "Total Kehilangan",
            noTarget: "Target belum ditetapkan",
            ytdScope: "(YTD {year})",
            operationalEfficiency: "Efisiensi Operasional",
            target: "Target",
            actual: "Aktual",
            farmerParticipation: "Partisipasi Petani - Sebaran Kontribusi",
            totalInput: "Total Input",
            totalOutput: "Total Output",
            activeFarmers: "Petani Aktif",
            rawIntake: "Input Mentah (Cherry Diterima)",
            processing: "Pemrosesan (Cherry Diproses)",
            output: "Output (Gabah Dihasilkan)",
            currentPeriod: "Periode Saat Ini",
            previousPeriod: "Periode Sebelumnya",
            volumePerTopFarmers: "Volume per Petani Teratas",
            cumulativeImpact: "Dampak Kumulatif (%)",
            deliveries: "Pengiriman (kg)",
            operational: "Operasional",
            volume: "Volume (kg)",
            cumulative: "Kumulatif (%)",
            to: "sampai",
            ranges: {
                today: "Hari Ini",
                week: "Minggu",
                month: "Bulan",
                year: "Tahun",
                all: "Semua",
            },
        },
        continue: "Lanjutkan",
        farmerId: "ID Petani",
        farmerName: "Nama Petani",
        farmerAddress: "Alamat Petani",
        quality: "Kualitas",
        quantity: "Kuantitas",
        importAll: "Impor Semua",
        importSelected: "Impor yang Dipilih",
        fileLoaded: "Berkas berhasil dimuat",
        incorrectHeaders: "Header salah",
        processingBatch: "Memproses Batch",
        purchaseOrder: "Pesanan Pembelian",
        buyingStationDetails: "Detail Stasiun Pembelian",
        buyingStationUsers: "Pengguna Stasiun Pembelian",
        activityLog: "Log Aktivitas",
        startDate: "Tanggal Mulai",
        endDate: "Tanggal Akhir",
        purchasingOrder: "Pesanan Pembelian",
        totalCoffeeCherry: "Total Biji Kopi Cherry",
        airHumidity: "Kelembapan Udara",
        density: "Kepadatan",
        temperature: "Suhu",
        beanMoistureContent: "Kandungan Air Biji Kopi",
        processType: "Jenis Proses",
        batchRating: "Pilih Rating Batch",
        purchaseDate: "Tanggal Pembelian",
        selectFarmer: "Pilih Petani",
        selectFarm: "Pilih Perkebunan",
        selectPlantation: "Pilih Perkebunan",
        coffeeVariety: "Varietas Kopi",
        coffeeSpecies: "Spesies Kopi",
        coffeeCherryQuantity: "Kuantitas Biji Kopi Cherry",
        coffeeCherryQuality: "Kualitas Biji Kopi Cherry",
        coffeeType: "Tipe Kopi",
        pricePerKg: "Harga Per Kg",
        receiptNo: "Nomor Kwitansi",
        processingDone: "Pengolahan Selesai",
        processedCoffeeOut: "Kopi yang Diproses Keluar",
        farmer: "Petani",
        farm: "Perkebunan",
        plantation: "Perkebunan",
        farmers: "Petani",
        selectCrop: "Pilih Tanaman",
        farmLimitUsed: "Batas Penggunaan Perkebunan",
        phoneNumber: "Nomor Telepon",
        farmSize: "Ukuran Perkebunan",
        farmLocation: "Lokasi Perkebunan",
        date: "Tanggal",
        status: "Status",
        noFarmers: "Tidak Ada Petani Ditemukan",
        approveReject: "Terima / Tolak",
        farms: "Perkebunan",
        crops: "Tanaman",
        equipment: "Peralatan",
        noFarms: "Tidak Ada Perkebunan Ditemukan",
        views: "Lihat",
        selectStatus: "Pilih Status",
        approved: "Disetujui",
        rejected: "Ditolak",
        reject: "Tolak",
        approve: "Setujui",
        conclude:"Selesaikan",
        cancel: "Batal",
        add: "Tambah",
        describeYourReason: "Deskripsikan alasan Anda di sini",
        userInformation: "Informasi Pengguna",
        userFarmRequest: "Permintaan Perkebunan Pengguna",
        userFarmInformation: "Informasi Perkebunan Pengguna",
        activity: "Aktivitas",
        activityType: "Tipe Aktivitas",
        farmZone: "Zona Perkebunan",
        farmerView: "Tampilan Petani",
        cropType: "Tipe Tanaman",
        cropVarity: "Varietas Tanaman",
        area: "Luas",
        cost: "Biaya",
        geofence: "Geofence",
        map_views: "Tampilan Peta",
        viewAllFarms: "Lihat Semua Perkebunan",
        farmersDetails: "Detail Petani",
        download: "Unduh",
        pOrder: {
          addNew: "Tambah Baru",
          viewAll: "Lihat Semua",
          selectDate: "Pilih tanggal",
          makeSelection: "Pilih salah satu",
          coffeeType: "Tipe kopi kuantitas",
          enterPrice: "Masukkan Harga",
          reqPurchaseDate: "Tanggal pembelian diperlukan",
          reqFarmer: "Petani diperlukan",
          reqCoffeeQnty: "Kuantitas Biji Kopi Cherry diperlukan",
          reqPrice: "Harga Per Kg diperlukan",
          grandTotal: "TOTAL BESAR",
          selectDateRange: "Pilih Rentang Tanggal",
          import: "Impor",
          purchaseId: "ID Pembelian",
          purchaseDate: "Tanggal Pembelian",
          farmerName: "Nama Petani",
          quality: "Kualitas",
          quantity: "Kuantitas",
          pricePerKg: "Harga Per Kg",
          selectBuyingStation: "Pilih stasiun pembelian",
          searchUser: "Cari Pengguna",
        },
        farmActivity: "Aktivitas Perkebunan",
        showOnMap: "Tampilkan di Peta",
        farmInformation: "Informasi Perkebunan",
        dateOfEntry: "Tanggal Masuk",
        farmID: "ID Perkebunan",
        ownershipType: "Tipe Kepemilikan",
        locationAddress: "Alamat Lokasi",
        goalType: "Tipe Tujuan",
        totalSize: "Ukuran Total",
        zones: "Zona",
        farmActivities: "Aktivitas Perkebunan",
        farmDetails: "Detail Perkebunan",
        totalFarmsRegistered: "Total Perkebunan Terdaftar",
        totalFarmArea: "Total Luas Perkebunan",
        totalZone: "Total Zona",
        zone: "Zona",
        totalCost: "Total Biaya",
        selectFarmZone: "Pilih Zona / Perkebunan",
        productionType: "Tipe Produksi",
        certifications: "Sertifikasi",
        geofences: "Geofences",
        farmsChart: "Grafik Perkebunan",
        
        
    // Buying Station specific translations
    buyingStations: "Stasiun Pembelian",
    registerBuyingStation: "Daftarkan Stasiun Pembelian",
    registerFactory: "Daftarkan Pabrik",
    loadingFactory: "Memuat Pabrik...",
    loadingBuyingStation: "Memuat Stasiun Pembelian...",
    searchBuyingStation: "Cari Stasiun Pembelian",
    searchFactory: "Cari Pabrik",
    searchSociety: "Cari Masyarakat",
    nameAndId: "Nama / ID",
    email: "Email",
    mobileNumber: "Nomor Ponsel",
    role: "Peran",
    actions: "Aksi",
    view: "Lihat",
    edit: "Ubah",
    activate: "Aktifkan",
    deactivate: "Nonaktifkan",
    operator: "Operator",
    supplier: "Pemasok",
    active: "Aktif",
    deactivated: "Dinonaktifkan",
    activatedSuccessfully: "Stasiun pembelian berhasil diaktifkan",
    deactivatedSuccessfully: "Stasiun pembelian berhasil dinonaktifkan",
  
    factoryActivatedSuccessfully: "Pabrik berhasil diaktifkan",
    factoryDeactivatedSuccessfully: "Pabrik berhasil dinonaktifkan",
    factoryRegisteredSuccessfully: "Pabrik berhasil didaftarkan",
    
    // Buying Station Details specific translations
    userDetails: "Detail Pengguna",
    name: "Nama",
    provinceState: "Provinsi/Negara Bagian",
    villageCityTown: "Desa/Kota/Kecamatan",
    country: "Negara",
    associatedFarms: "Perkebunan Terkait",
    back: "Kembali",
    addPurchaseOrder: "Tambah Pesanan Pembelian",
    cherryCollection: "Koleksi Ceri",
    addCherryCollection: "Tambah Koleksi Ceri",
    search: "Cari",
    orderId: "ID Pesanan",
    farmFarmer: "Perkebunan / Petani",
    coffeeSpeciesVariety: "Spesies / Varietas Kopi",
    quantityPrice: "Kuantitas / Harga",
    delete: "Hapus",
    
    // Processing Batch specific translations
    addProcessingBatch: "Tambah Batch Pengolahan",
    batchId: "ID Batch",
    lots: "Lot",
    greenCoffeeOut: "Kopi Hijau Keluar",
    startEndDate: "Tanggal Mulai / Tanggal Akhir",
    
    // Associated Farms specific translations
    addFarm: "Tambah Perkebunan",
    farmNameAndId: "Nama & ID Perkebunan",
    addressOfProduction: "Alamat Produksi",
    areaHa: "Luas (ha)",
    type: "Tipe",
    eudrDeforestationStatus: "Status Deforestasi EUDR",
    eudrDeforestationStatusTT: "Status Penilaian Risiko Deforestasi EUDR",
    zeroNegligibleProbability: "Probabilitas Nol/Diabaikan",
    assessments: "Penilaian",
    riskAssessment: "Penilaian Risiko",
    compliant: "Sesuai",
    nonCompliant: "Tidak Sesuai",
    pending: "Tertunda",
    dateOfSubmission: "Tanggal Pengajuan",
    dateOfExpiry: "Tanggal Kedaluwarsa",
    selectFarms: "Pilih Kebun",
    reviewSelection: "Tinjau Pilihan",
    next: "Berikutnya",
    reviewMappingPrompt: "Anda telah memilih {count} kebun. Konfirmasi untuk memetakannya ke stasiun pembelian ini.",
    confirmMapping: "Konfirmasi Pemetaan",
    farmsMappedSuccess: "Kebun berhasil dipetakan",
    farmsMappedError: "Gagal memetakan kebun",
    owner: "Pemilik",

    buyingStationOrder: {
      bulkImport: {
        importBulkData: "Impor Data secara Massal",
        importButton: "Impor Pesanan Pembelian secara Massal",
        importButtonCherry: "Impor Pengumpulan Ceri secara Massal",
        title: "Impor Data Pesanan Pembelian Massal",
        titleCherry: "Impor Massal Data Pengumpulan Ceri",
        // Upload tab
        templateNote: "Unduh dan gunakan template di bawah ini untuk mengimpor pesanan pembelian secara massal.",
        selectTemplate: "Pilih Template",
        templateXls: "Impor Format XLS",
        downloadXls: "Unduh Format XLS",
        selectFile: "Pilih file untuk Mengunggah Data",
        dropHere: "atau seret dan lepas di sini",
        fileUploaded: "File berhasil diunggah.",
        importantNote: "Catatan Penting",
        importantNoteDetail:
          "Silakan gunakan template yang disediakan di atas untuk unggahan massal. Format lain akan mengakibatkan kegagalan.",
        unsupportedFileFormat: "Format file ini tidak didukung.",
        invalidFileFormat: "Silakan unggah file .xlsx, .xls atau .csv yang valid menggunakan template yang disediakan.",
        templateErrorIntro:
          "File yang diunggah tidak cocok dengan template yang diperlukan. Unduh template dan coba lagi.",
        importingTitle: "Mengimpor...",
        importingNote:
          "File yang Anda unggah sedang diproses.\nKami akan memberi tahu Anda setelah file berhasil diunggah.",
        // Result page
        importCompleted: "Impor Selesai",
        recordsReadyToImport: "catatan siap diimpor",
        tabTotalRecords: "Total Catatan",
        tabSuccess: "Berhasil",
        tabIssues: "Masalah",
        filterAll: "Semua",
        filterSuccess: "Berhasil",
        issuesDetected: "Masalah Terdeteksi",
        issuesDetectedHeading: "Ketidaksesuaian terdeteksi:",
        issuesDetectedDescription:
          "Beberapa baris memiliki masalah data (mis., tanggal pembelian tidak valid, petani, perkebunan atau data kopi tidak dikenal). Silakan tinjau dan selesaikan sebelum pengiriman akhir.",
        deleteRowsWithIssues: "Hapus baris dengan Ketidaksesuaian Data",
        // Table headers
        purchaseDate: "Tanggal Pembelian",
        farmer: "Petani",
        farm: "Perkebunan",
        buyingStation: "Stasiun Pembelian",
        coffeeQuantityQuality: "Kuantitas & Kualitas Kopi",
        plantation: "Perkebunan",
        coffeeSpecies: "Spesies Kopi",
        coffeeVariety: "Varietas Kopi",
        coffeeType: "Tipe Kopi",
        coffeeCherryQuantity: "Kuantitas Biji Kopi Cherry",
        coffeeCherryQuality: "Kualitas Biji Kopi Cherry",
        pricePerKg: "Harga Per Kg",
        lotId: "ID Lot",
        photos: "Foto",
        // Actions / dialogs
        purchaseOrder: "Pesanan Pembelian",
        detailsTitle: "Detail Pesanan Pembelian",
        editRecord: "Edit catatan",
        deleteRecord: "Hapus catatan",
        deleteRecordConfirm:
          "Apakah Anda yakin ingin menghapus catatan ini? Tindakan ini tidak dapat dibatalkan.",
        deleteDiscrepancyConfirm:
          "Apakah Anda yakin ingin menghapus semua {count} baris dengan masalah? Tindakan ini tidak dapat dibatalkan.",
        cancelImportTitle: "Batalkan Impor",
        cancelImportConfirm:
          "Apakah Anda yakin ingin membatalkan impor ini? Catatan yang tervalidasi tidak akan dapat diimpor lagi.",
        cancelImportConfirmBtn: "Batalkan Impor",
        importConfirm: "Impor {count} catatan valid sekarang?",
        recordUpdatedSuccess: "Catatan berhasil diperbarui.",
        recordsDeletedSuccess: "Catatan berhasil dihapus.",
        importCancelledSuccess: "Impor berhasil dibatalkan.",
        genericError: "Terjadi kesalahan. Silakan coba lagi.",
        noDataFound: "Tidak ada data ditemukan.",
        // Edit dialog
        selectFactory: "Pilih pabrik",
        selectFarmer: "Pilih Petani",
        selectFarm: "Pilih Perkebunan",
        selectPlantation: "Pilih Perkebunan",
        submit: "Kirim",
        addImage: "Tambah Gambar",
        addedBy: "Ditambahkan oleh",
        close: "Tutup",
        // Success dialog
        successDialogTitle: "Pesan Berhasil",
        importedSuccessfully: "{count} pesanan pembelian telah berhasil diimpor.",
        // History
        historyFile: "Nama File",
        historyImportedOn: "Diimpor Pada",
        historyEmpty: "Belum ada riwayat impor massal.",
        statusValidating: "Memvalidasi",
        statusSuccess: "Diimpor",
        statusCancelled: "Dibatalkan",
        // Error-code labels (tooltips / field messages)
        errorInvalidPurchaseDate: "Tanggal pembelian tidak valid.",
        errorMissingPurchaseDate: "Tanggal pembelian hilang.",
        errorMissingMemberId: "ID Anggota hilang.",
        errorInvalidMemberIdFormat: "Format ID Anggota tidak valid. Yang diharapkan: Nama Petani - Nama Stasiun Pembelian - ID Perkebunan.",
        errorInvalidFarmerName: "Petani tidak ditemukan dalam organisasi Anda.",
        errorInvalidBuyingStationName: "Stasiun pembelian tidak ditemukan dalam organisasi Anda.",
        errorInvalidFarm: "Perkebunan tidak ditemukan dalam organisasi Anda.",
        errorMissingQuantity: "Kuantitas biji kopi cherry hilang.",
        errorInvalidQuantity: "Kuantitas biji kopi cherry harus berupa angka lebih besar dari nol.",
        errorMissingQuality: "Kualitas biji kopi cherry hilang.",
        errorInvalidQuality: "Kualitas biji kopi cherry tidak dikenali.",
        errorMissingPrice: "Harga hilang.",
        errorInvalidPrice: "Harga harus berupa angka yang valid.",
        // Filter chip short labels
        chipInvalidPurchaseDate: "Tanggal Pembelian Tidak Valid",
        chipMissingPurchaseDate: "Tanggal Pembelian Hilang",
        chipMissingMemberId: "ID Anggota Hilang",
        chipInvalidMemberIdFormat: "Format ID Anggota Tidak Valid",
        chipInvalidFarmerName: "Petani Tidak Valid",
        chipInvalidBuyingStationName: "Stasiun Pembelian Tidak Valid",
        chipInvalidFarm: "Perkebunan Tidak Valid",
        chipMissingQuantity: "Kuantitas Hilang",
        chipInvalidQuantity: "Kuantitas Tidak Valid",
        chipMissingQuality: "Kualitas Hilang",
        chipInvalidQuality: "Kualitas Tidak Valid",
        chipMissingPrice: "Harga Hilang",
        chipInvalidPrice: "Harga Tidak Valid",

      },
    },
    processingBatchBulkImport: {
      bulkImport: "Impor Batch Pemrosesan Massal",
      title: "Impor Massal Batch Pemrosesan",
      instructions: "Unggah file CSV atau XLSX menggunakan template di bawah ini. Setiap baris membuat satu batch pemrosesan.",
      downloadCsv: "Unduh template CSV",
      downloadXlsx: "Unduh template XLSX",
      selectFile: "Pilih file CSV atau XLSX",
      rowsParsed: "{count} baris siap diimpor.",
      import: "Impor",
      imported: "Mengimpor {created} dari {total} batch.",
      failed: "{failed} baris gagal.",
      rowError: "Baris {row}",
      emptyFile: "File tidak memiliki baris data.",
      missingColumns: "Kolom yang diperlukan tidak ada: {columns}",
      noBuyingStation: "Tidak ada stasiun pembelian yang dipilih.",
      validating: "Memvalidasi baris…",
      total: "Total",
      valid: "Valid",
      invalid: "Tidak Valid",
      all: "Semua",
      statusValid: "Valid",
      statusInvalid: "Tidak Valid",
      issues: "Masalah",
      back: "Kembali",
      importValid: "Impor {count} baris valid",
      done: "Selesai",
      rowCol: "Baris",
      startDateCol: "Tanggal Proses",
      purchaseOrdersCol: "Kode Pembelian",
      processTypeCol: "Jenis Proses",
      gradeCol: "Grade",
      seasonCol: "Musim",
      statusCol: "Status",
      purchaseDateCol: "Tanggal Pembelian",
      processDateCol: "Tanggal Proses",
      parchmentCol: "Parchment (Kg)",
      bagsCol: "Karung",
      vehiclePlateCol: "Plat Nomor Kendaraan",
      harvestedCol: "Dipanen",
      pulpedCol: "Dipulp",
      washedCol: "Dicuci",
      dryingStartedCol: "Pengeringan Dimulai",
      movedToStoreCol: "Dipindah ke Gudang",
      templateNote: "Unduh dan gunakan template di bawah ini untuk mengimpor batch pemrosesan secara massal.",
      selectTemplate: "Pilih Template",
      templateCsv: "Format Impor CSV",
      templateXls: "Format Impor XLS",
      downloadCsvFormat: "Unduh Format CSV",
      downloadXls: "Unduh Format XLS",
      importingTitle: "Impor Massal Batch Pemrosesan",
      importingNote: "File yang Anda unggah sedang diproses.\nJangan klik batal, tutup, atau refresh halaman ini untuk menghindari gangguan.",
      importantNote: "Catatan Penting",
      importantNoteDetail: "Gunakan template yang disediakan di atas untuk impor massal batch pemrosesan. Format lain akan menyebabkan kegagalan.",
      invalidFileFormat: "Harap unggah file .csv, .xlsx, atau .xls yang valid menggunakan template yang disediakan.",
      unsupportedFileFormat: "Format file ini tidak didukung.",
      templateErrorIntro: "File yang diunggah tidak sesuai dengan template yang diperlukan. Unduh template dan coba lagi.",
      importCompleted: "Impor Selesai",
      tabTotalRecords: "Total Rekaman",
      tabSuccess: "Berhasil",
      tabIssues: "Masalah",
      filterAll: "Semua",
      filterSuccess: "Berhasil",
      issuesDetected: "Masalah Terdeteksi",
      issuesDetectedHeading: "Masalah Terdeteksi:",
      issuesDetectedDescription: "Beberapa baris memiliki masalah data (mis., tanggal hilang, jenis proses tidak dikenal, nilai parchment tidak valid). Harap tinjau dan selesaikan sebelum pengajuan akhir.",
      deleteRowsWithIssues: "Hapus baris bermasalah",
      editRecord: "Edit rekaman",
      deleteRecord: "Hapus rekaman",
      deleteRecordConfirm: "Apakah Anda yakin ingin menghapus rekaman ini? Tindakan ini tidak dapat dibatalkan.",
      deleteDiscrepancyConfirm: "Apakah Anda yakin ingin menghapus semua {count} baris bermasalah? Tindakan ini tidak dapat dibatalkan.",
      cancelImportTitle: "Batalkan Impor",
      cancelImportConfirm: "Apakah Anda yakin ingin membatalkan impor ini? Rekaman yang divalidasi tidak akan dapat diimpor lagi.",
      cancelImportConfirmBtn: "Batalkan Impor",
      importConfirm: "Impor {count} rekaman valid sekarang?",
      recordUpdatedSuccess: "Rekaman berhasil diperbarui.",
      recordsDeletedSuccess: "Rekaman berhasil dihapus.",
      importCancelledSuccess: "Impor berhasil dibatalkan.",
      genericError: "Terjadi kesalahan. Silakan coba lagi.",
      noDataFound: "Data tidak ditemukan.",
      editRecordTitle: "Edit Rekaman",
      submit: "Kirim",
      detailsTitle: "Detail Batch Pemrosesan",
      close: "Tutup",
      successDialogTitle: "Pesan Berhasil",
      importedSuccessfully: "{count} rekaman batch pemrosesan berhasil diimpor.",
      historyFile: "Nama File",
      historyImportedOn: "Diimpor Pada",
      historyEmpty: "Belum ada riwayat impor massal.",
      statusValidating: "Memvalidasi",
      statusSuccess: "Diimpor",
      statusCancelled: "Dibatalkan",
      errorCodePurchaseDateRequired: "Tanggal pembelian wajib diisi.",
      errorCodeInvalidPurchaseDate: "Format tanggal pembelian tidak dikenali.",
      errorCodeProcessDateRequired: "Tanggal proses wajib diisi.",
      errorCodeInvalidProcessDate: "Format tanggal proses tidak dikenali.",
      errorCodeUnknownProcessType: "Jenis proses tidak dikenali.",
      errorCodeNoOrdersForDate: "Tidak ada pesanan pembelian yang ditemukan untuk tanggal pembelian yang diberikan.",
      errorCodeParchmentInvalid: "Nilai parchment (Kg) tidak valid.",
      errorCodeParchmentExceedsCherry: "Parchment (Kg) tidak boleh melebihi total kuantitas kopi cherry.",
      errorCodeInvalidData: "Satu atau beberapa bidang mengandung data tidak valid.",
      chipPurchaseDateRequired: "Tanggal Pembelian Diperlukan",
      chipInvalidPurchaseDate: "Tanggal Pembelian Tidak Valid",
      chipProcessDateRequired: "Tanggal Proses Diperlukan",
      chipInvalidProcessDate: "Tanggal Proses Tidak Valid",
      chipUnknownProcessType: "Jenis Proses Tidak Dikenal",
      chipNoOrdersForDate: "Tidak Ada Pesanan untuk Tanggal Ini",
      chipParchmentInvalid: "Parchment Tidak Valid",
      chipParchmentExceedsCherry: "Parchment Melebihi Cherry",
      chipInvalidData: "Data Tidak Valid",
    },
    greenCoffee: {
      bulkImport: {
        importButton: "Impor Kopi Hijau secara Massal",
        title: "Impor Data Kopi Hijau Massal",
        breadcrumb: "Ikhtisar Kopi > Penggilingan Kering",
        tabImport: "Impor",
        tabHistory: "Riwayat",
        templateNote:
          "Unduh dan gunakan template di bawah ini untuk mengimpor kopi hijau secara massal.",
        selectTemplate: "Pilih Template",
        templateXls: "Impor Format XLS",
        importingTitle: "Impor Data Kopi Hijau Massal",
        importingNote:
          "File yang Anda unggah sedang diproses.\nJangan klik batal, tutup, atau segarkan halaman ini untuk menghindari gangguan.",
        importCompleted: "Impor Selesai",
        tabTotalRecords: "Total Catatan",
        tabSuccess: "Berhasil",
        tabFailed: "Gagal",
        tabIssues: "Masalah",
        tabDataDiscrepancies: "Ketidaksesuaian Data",
        filterAll: "Semua",
        filterSuccess: "Berhasil",
        filterIssues: "Masalah",
        issuesDetectedHeading: "Masalah Terdeteksi:",
        issuesDetectedDescription:
          "Beberapa lot memiliki masalah data (mis., nomor hasil tidak valid, nomor hasil tidak ada dalam sistem). Silakan tinjau dan selesaikan sebelum pengiriman akhir.",
        deleteLotsWithDataDiscrepancies: "Hapus Lot dengan Ketidaksesuaian Data",
        lotId: "ID Lot",
        lotIdAndOutturn: "ID Lot & Hasil",
        grower: "Petani",
        coffeeType: "Tipe Kopi",
        grossAndNetWeight: "Berat Kotor & Berat Bersih",
        issuesDetected: "Masalah Terdeteksi",
        issueOutturnNumberMismatchTitle: "Nomor hasil tidak cocok:",
        issueOutturnNumberMismatchDescription:
          "Hasil ini tidak cocok dengan catatan Pengiriman Pergamen yang ada. Pastikan Nomor Hasil telah ditautkan secara manual di tingkat Pabrik sebelum mengunggah ulang.",
        issueDuplicateOutturnNumberTitle: "Nomor Hasil Ganda:",
        issueDuplicateOutturnNumberDescription:
          "Nomor hasil muncul beberapa kali dalam dokumen yang diunggah ini.",
        issueMissingOutturnNumberTitle: "Nomor Hasil Hilang:",
        issueMissingOutturnNumberDescription:
          "Baris yang diunggah tidak berisi Nomor Hasil. Pengenal Hasil yang unik dan valid diperlukan untuk mencocokkan catatan dengan sistem pabrik.",
        issueGrowerIdentityMismatchTitle: "Ketidaksesuaian Identitas Petani:",
        issueGrowerIdentityMismatchDescription:
          "Nomor hasil terdaftar dalam sistem kami atas nama Petani {mobileGrowerName}, tetapi file yang diunggah menetapkannya ke {xlsGrowerName}. Penimpaan data dibatasi.",
        issueMissingGrowerCredentialsTitle: "Kredensial Petani Hilang:",
        issueMissingGrowerCredentialsDescription:
          "Catatan tidak memiliki Nama Petani atau ID Petani. Bidang data ini wajib untuk memverifikasi kepemilikan pabrik sebelum batch dapat direkonsiliasi.",
        editRecord: "Edit catatan",
        deleteRecord: "Hapus catatan",
        downloadXls: "Unduh Format XLS",
        selectFile: "Pilih file untuk Mengunggah Data",
        dropHere: "atau seret dan lepas di sini",
        importantNote: "Catatan Penting",
        importantNoteDetail:
          "Silakan gunakan template yang disediakan di atas untuk mengimpor kopi hijau secara massal. Format lain akan mengakibatkan kegagalan.",
        invalidFileFormat: "Silakan unggah file .xlsx atau .xls yang valid menggunakan template yang disediakan.",
        unsupportedFileFormat: "Format file ini tidak didukung.",
        importFailed: "Impor Gagal",
        importFailedIntro:
          "File tidak dapat diimpor. Periksa format template dan data baris, lalu coba lagi.",
        templateErrorIntro:
          "File yang diunggah tidak cocok dengan template yang diperlukan. Unduh template XLS dan coba lagi.",
        tryAgain: "Coba Lagi",
        errorDetails: "Detail",
        historyEmpty: "Belum ada riwayat impor massal.",
        // Validation review / import flow
        validationSummaryTitle: "Ringkasan Validasi",
        recordsReadyToImport: "catatan siap diimpor",
        editRecordTitle: "Edit Catatan",
        growerCode: "Kode Petani",
        growerName: "Nama Petani",
        greenBeansTotal: "Berat Input Dengan Karung (Kg)",
        selectedCount: "dipilih",
        deleteSelected: "Hapus yang Dipilih",
        deleteRecordConfirm:
          "Apakah Anda yakin ingin menghapus catatan ini? Tindakan ini tidak dapat dibatalkan.",
        deleteSelectedConfirm:
          "Apakah Anda yakin ingin menghapus {count} catatan yang dipilih? Tindakan ini tidak dapat dibatalkan.",
        deleteDiscrepancyConfirm:
          "Apakah Anda yakin ingin menghapus semua {count} lot dengan ketidaksesuaian data? Tindakan ini tidak dapat dibatalkan.",
        cancelImportTitle: "Batalkan Impor",
        cancelImportConfirm:
          "Apakah Anda yakin ingin membatalkan impor ini? Catatan yang tervalidasi tidak akan dapat diimpor lagi.",
        cancelImportConfirmBtn: "Batalkan Impor",
        importConfirm: "Impor {count} catatan valid sekarang?",
        recordUpdatedSuccess: "Catatan berhasil diperbarui.",
        recordsDeletedSuccess: "Catatan berhasil dihapus.",
        importCancelledSuccess: "Impor berhasil dibatalkan.",
        importSuccess: "Impor berhasil diselesaikan.",
        genericError: "Terjadi kesalahan. Silakan coba lagi.",
        // Issue / error-code labels
        issueInvalidDataTitle: "Data Tidak Valid:",
        issueInvalidDataDescription:
          "Satu atau beberapa bidang berisi data tidak valid. Silakan tinjau dan perbaiki.",
        errorCodeOutturnMismatch:
          "Nomor hasil ini tidak cocok dengan catatan pengiriman pergamen yang ada.",
        errorCodeOutturnMissing: "Nomor hasil hilang.",
        errorCodeOutturnDuplicate:
          "Nomor hasil ini terduplikasi dalam file atau sudah ada dalam sistem.",
        errorCodeGrowerMismatch:
          "Nama/kode petani tidak cocok dengan pengiriman pergamen yang terdaftar.",
        errorCodeGrowerMissing: "Nama atau kode petani hilang.",
        errorCodeInvalidData: "Satu atau beberapa bidang berisi data tidak valid.",
        // History table
        historyFile: "Nama File",
        historyImportedOn: "Diimpor Pada",
        historyUploadedBy: "Diunggah Oleh",
        historyCreatedDate: "Tanggal Dibuat",
        historyTotalRecords: "Total Catatan",
        historyErrorRecords: "Catatan Kesalahan",
        // Bulk import status labels
        statusValidating: "Memvalidasi",
        statusSuccess: "Diimpor",
        statusCancelled: "Dibatalkan",
        // Edit record dialog
        editFieldId: "ID",
        inputWeightWithBags: "Berat Input Dengan Karung",
        qualityControl: "Kontrol Kualitas",
        submit: "Kirim",
        noMillingOutputs: "Tidak ada detail keluaran penggilingan.",
        millingCleanCoffee: "Kopi Bersih (Detail Keluaran Penggilingan)",
        millingBags: "Karung (Detail Keluaran Penggilingan)",
        millingPockets: "Kantong (Detail Keluaran Penggilingan)",
        millingWeight: "Berat (Detail Keluaran Penggilingan)",
        millingBulkOutturn: "Hasil Curah (Detail Keluaran Penggilingan)",
        millingRatio: "Rasio (Detail Keluaran Penggilingan)",
        // Detail dialog
        detailsTitle: "Detail Kopi Hijau",
        outturnNo: "No. Hasil",
        close: "Tutup",
        // Success dialog
        successDialogTitle: "Pesan Berhasil",
        importedSuccessfully:
          "{count} catatan kopi hijau telah berhasil diimpor.",
        // Filter chip short labels (per error category)
        chipOutturnMismatch: "Nomor Hasil Tidak Cocok",
        chipOutturnMissing: "Nomor Hasil Hilang",
        chipOutturnDuplicate: "Nomor Hasil Ganda",
        chipGrowerMismatch: "Ketidaksesuaian Identitas Petani",
        chipGrowerMissing: "Kredensial Petani Hilang",
        chipInvalidData: "Data Tidak Valid",
      },
      processGreenCoffee: "Proses Kopi Hijau",
      addedBy: "Ditambahkan oleh",
      selectProductType: "Pilih Tipe Produk",
      processDate: "Tanggal Proses",
      selectProcessingBatch: "Pilih Batch Pengolahan",
      lotIdAndDate: "ID Batch & Tanggal",
      typeAndQuantity: "Tipe & Kuantitas",
      supplier: "Pemasok",
      outturnNumber: "Nomor Hasil",
      totalInputQuantity: "Total Kuantitas Input (kg)",
      qualityControl: "Kontrol Kualitas",
      airHumidity: "Kelembapan Udara (nilai dalam %)",
      density: "Kepadatan (kg/cm3)",
      greenCoffeeQualityScore: "Skor Kualitas Kopi Hijau",
      batchProduction: "Produksi Batch",
      unsortedGreenBeans: "Biji Hijau Belum Disortir (kg)",
      batchProductionDensity: "Kepadatan Produksi Batch (kg/cm3)",
      percentagePrimaryDefect: "Persentase Cacat Primer",
      percentageSecondaryDefect: "Persentase Cacat Sekunder",
      greenBeans: "Biji Hijau",
      totalGreenBeans: "Total Biji Hijau (kg)",
      unitSize: "Ukuran Unit (kg)",
      totalBags: "Total Karung",
      leftoverQuantity: "Kuantitas Sisa",
      leftoverQuantityDesc: "Kuantitas Sisa adalah jumlah tersisa yang tidak dapat membentuk satu karung penuh. Ini mewakili kuantitas yang tersisa setelah mengisi jumlah maksimum unit lengkap dari total pasokan.",
      expiryDate: "Tanggal Kedaluwarsa",
      label: "Label",
      qualityControlButton: "Kontrol Kualitas",
      valueInPercent: "nilai dalam %",
      kgCm3: "kg/cm3",
      complete: "Selesai",
      lotIdOutturnNo: "ID Batch / No. Hasil",
      startDate: "Tanggal Mulai",
      greenBeansQualityGrading: "Penilaian Kualitas Biji Hijau",
      totalQuantity: "Kuantitas Total",
      quantity: "Kuantitas",
      packing: "Pengemasan",
      bag: "Karung",
      qualityScore: "Skor Kualitas",
      noLotsYet: "Belum ada lot. Tambahkan nilai kualitas dari alur pembuatan.",
      lotId: "ID Batch",
      percentage: "Persentase",
      createQualityGrade: "Buat Nilai Kualitas",
      finishGrading: "Selesaikan Penilaian",
      finishGradingDesc: "Setelah selesai, Anda tidak dapat menilai lot ini lagi. Limbah akan dihitung otomatis setelah penyelesaian.",
      finishGradingButton: "Selesaikan Penilaian",
      addNewQualityGrade: "Tambah Nilai Kualitas Baru",
      totalGreenBeansExceeded: "Total kuantitas yang dinilai tidak boleh melebihi Total Kopi Hijau.",
      lotIdAlreadyExists: "ID lot ini sudah digunakan. Gunakan ID lot yang berbeda.",
      toAddRecord: "untuk menambah catatan.",
      registeredSuccess: "Kopi hijau berhasil didaftarkan",
      exportNotImplemented: "Ekspor belum diimplementasikan",
      processingBatchRequired: "Batch pengolahan wajib diisi",
      outturnAvailable: "Nomor hasil tersedia",
      outturnExists: "Nomor hasil ini sudah ada. Silakan masukkan yang unik.",
      totalGreenBeansRequired: "Total kopi hijau wajib diisi",
      enterHere: "Masukkan di sini",
      viewTitle: "Penilaian Kualitas Biji Hijau",
      parchmentInformation: "Informasi Pergamen",
      processInformation: "Informasi Proses",
      greenBeansInformation: "Informasi Biji Hijau",
      traceabilityLabel: "Label Ketertelusuran",
      waste: "Limbah",
      downloadLabel: "Unduh Label",
      startCupping: "Mulai Cupping",
      cuppingHistory: "Riwayat Cupping",
      noDataFound: "Tidak ada data ditemukan.",
      noParchmentBatches: "Tidak ada batch pergamen yang tertaut.",
      noQualityGrades: "Tidak ada nilai kualitas yang tercatat.",
      batchId: "ID Batch",
      species: "Spesies",
      variety: "Varietas",
      process: "Proses",
      batchRating: "Rating Batch",
      humidity: "Kelembapan",
      totalCoffeeCherryQty: "Kuantitas Cherry Kopi Total",
      weightBeforeProcessing: "Berat Sebelum Pengolahan",
      numberOfBags: "Jumlah Karung",
      externalId: "ID Eksternal",
      qrCode: "Kode QR",
      latestCuppingScore: "Skor Cupping Terbaru",
      totalWaste: "Total Limbah",
      close: "Tutup",
      unitSizeKgBag: "Ukuran Unit (kg/karung)",
      grade: "Tingkat",
      selectGrade: "Pilih tingkat",
      quantityRequired: "Kuantitas wajib diisi",
      quantityMustBePositive: "Kuantitas harus lebih dari 0",
      unitSizeRequired: "Ukuran unit wajib diisi",
      unitSizeMustBePositive: "Ukuran unit harus lebih dari 0",
      gradeRequired: "Tingkat wajib diisi",
      labelRequired: "Label wajib diisi",
      cupping: "Cupping",
      cuppingInformation: "Informasi Cupping",
      cupperName: "Nama Pencicip",
      cuppingDate: "Tanggal Cupping",
      enterCupperName: "Masukkan nama pencicip",
      attachFiles: "Lampirkan File",
      selectFilesToUpload: "Pilih File untuk Mengunggah Data",
      orDragAndDrop: "atau seret dan lepas di sini",
      lightRoast: "Sangrai Ringan",
      roastingTime: "Waktu Penyangraian",
      roastingTemperature: "Suhu Penyangraian",
      qualities: "Kualitas",
      uniformity: "Keseragaman",
      cleanCup: "Cangkir Bersih",
      sweetness: "Kemanisan",
      overall: "Keseluruhan",
      defects: "Cacat",
      finalScore: "Skor Akhir",
      sessionDetails: "Detail sesi",
      noCuppingHistory: "Tidak ada riwayat cupping untuk kopi hijau ini.",
      cuppingDataSaved: "Data cupping disimpan.",
      date: "Tanggal",
      roast: "Sangrai",
      score: "Skor",
    },
    confirmDialog: {
      delete: {
        title: "Hapus Stasiun Pembelian",
        message: "Apakah Anda yakin ingin menghapus stasiun pembelian ini?",
        confirmBtn: "Hapus",
      },
      activate: {
        title: "Aktifkan",
        message: "Apakah Anda yakin ingin mengaktifkan {entity} ini?",
        confirmBtn: "Aktifkan",
      },
      deactivate: {
        title: "Nonaktifkan",
        message: "Apakah Anda yakin ingin menonaktifkan {entity} ini?",
        confirmBtn: "Nonaktifkan",
      },
    },
    
    registerNewFactory: "Daftarkan Pabrik Baru",
    selectHowYouWantToProceed: "Pilih cara Anda ingin melanjutkan",
    single: "Tunggal",
    multiple: "Ganda",
    user: "Pengguna",
    createNewFactory: "Buat Pabrik Baru",
    factoryName: "Nama Pabrik",
    factoryNumber: "Nomor Pabrik",
    firstName: "Nama Depan",
    lastName: "Nama Belakang",
    primaryEmailAddress: "Alamat Email Utama",
    submit: "Kirim",
    downloadTemplate: "Unduh Template",
    templateInfo: "Unduh file template untuk melihat format yang diperlukan untuk pendaftaran massal.",
    templateFormat: "Mohon berikan file dalam format CSV.",
    selectFileToUpload: "Pilih file untuk mengunggah data",
    uploadFileOrDragAndDrop: "atau seret dan letakkan di sini",
  },
}